/**
 * Hand gestures & body parts emoji category with searchable keywords
 */
export const gestures = {
  name: 'Gestures',
  icon: '👋',
  emojis: [
    { emoji: '👋', keywords: ['wave', 'hello', 'hi', 'bye', 'hand'] },
    { emoji: '🤚', keywords: ['raised', 'back', 'hand', 'stop', 'high'] },
    { emoji: '🖐️', keywords: ['hand', 'splayed', 'fingers', 'five', 'stop'] },
    { emoji: '✋', keywords: ['hand', 'stop', 'high', 'five', 'raised'] },
    { emoji: '🖖', keywords: ['vulcan', 'spock', 'star', 'trek', 'live'] },
    { emoji: '👌', keywords: ['ok', 'okay', 'perfect', 'good', 'nice'] },
    { emoji: '🤌', keywords: ['pinched', 'italian', 'chef', 'kiss', 'fingers'] },
    { emoji: '🤏', keywords: ['pinch', 'small', 'tiny', 'little', 'bit'] },
    { emoji: '✌️', keywords: ['peace', 'victory', 'two', 'fingers', 'v'] },
    { emoji: '🤞', keywords: ['crossed', 'fingers', 'luck', 'hope', 'wish'] },
    { emoji: '🤟', keywords: ['love', 'you', 'rock', 'sign', 'ily'] },
    { emoji: '🤘', keywords: ['rock', 'metal', 'horns', 'devil', 'sign'] },
    { emoji: '🤙', keywords: ['call', 'shaka', 'hang', 'loose', 'phone'] },
    { emoji: '👈', keywords: ['point', 'left', 'direction', 'finger', 'back'] },
    { emoji: '👉', keywords: ['point', 'right', 'direction', 'finger', 'this'] },
    { emoji: '👆', keywords: ['point', 'up', 'finger', 'above', 'top'] },
    { emoji: '🖕', keywords: ['middle', 'finger', 'flip', 'off', 'rude'] },
    { emoji: '👇', keywords: ['point', 'down', 'finger', 'below', 'bottom'] },
    { emoji: '☝️', keywords: ['point', 'up', 'one', 'index', 'first'] },
    { emoji: '👍', keywords: ['thumbs', 'up', 'yes', 'good', 'like', 'approve'] },
    { emoji: '👎', keywords: ['thumbs', 'down', 'no', 'bad', 'dislike'] },
    { emoji: '✊', keywords: ['fist', 'power', 'punch', 'solidarity', 'raised'] },
    { emoji: '👊', keywords: ['fist', 'bump', 'punch', 'bro', 'power'] },
    { emoji: '🤛', keywords: ['fist', 'left', 'bump', 'punch'] },
    { emoji: '🤜', keywords: ['fist', 'right', 'bump', 'punch'] },
    { emoji: '👏', keywords: ['clap', 'applause', 'bravo', 'congrats', 'praise'] },
    { emoji: '🙌', keywords: ['raise', 'hands', 'celebrate', 'hooray', 'praise'] },
    { emoji: '👐', keywords: ['open', 'hands', 'hug', 'jazz', 'hands'] },
    { emoji: '🤲', keywords: ['palms', 'up', 'prayer', 'receive', 'give'] },
    { emoji: '🤝', keywords: ['handshake', 'deal', 'agree', 'partnership', 'meet'] },
    { emoji: '🙏', keywords: ['pray', 'please', 'thanks', 'hope', 'namaste'] },
    { emoji: '✍️', keywords: ['write', 'pen', 'sign', 'author', 'note'] },
    { emoji: '💅', keywords: ['nail', 'polish', 'beauty', 'manicure', 'sassy'] },
    { emoji: '🤳', keywords: ['selfie', 'phone', 'camera', 'photo', 'pic'] },
    { emoji: '💪', keywords: ['muscle', 'strong', 'flex', 'arm', 'power', 'gym'] },
    { emoji: '🦾', keywords: ['mechanical', 'arm', 'robot', 'prosthetic', 'bionic'] },
    { emoji: '🦿', keywords: ['mechanical', 'leg', 'prosthetic', 'robot', 'bionic'] },
    { emoji: '🦵', keywords: ['leg', 'kick', 'limb', 'thigh', 'knee'] },
    { emoji: '🦶', keywords: ['foot', 'kick', 'stomp', 'toe', 'step'] },
    { emoji: '👂', keywords: ['ear', 'listen', 'hear', 'sound', 'audio'] },
    { emoji: '🦻', keywords: ['ear', 'hearing', 'aid', 'deaf', 'accessibility'] },
    { emoji: '👃', keywords: ['nose', 'smell', 'sniff', 'scent', 'face'] },
    { emoji: '🧠', keywords: ['brain', 'think', 'smart', 'mind', 'intelligence'] },
    { emoji: '🫀', keywords: ['heart', 'organ', 'anatomical', 'cardio', 'beat'] },
    { emoji: '🫁', keywords: ['lungs', 'breathe', 'organ', 'respiratory', 'air'] },
    { emoji: '🦷', keywords: ['tooth', 'teeth', 'dentist', 'bite', 'dental'] },
    { emoji: '🦴', keywords: ['bone', 'skeleton', 'dog', 'calcium', 'body'] },
    { emoji: '👀', keywords: ['eyes', 'look', 'see', 'watch', 'stare'] },
    { emoji: '👁️', keywords: ['eye', 'look', 'see', 'watch', 'vision'] },
    { emoji: '👅', keywords: ['tongue', 'lick', 'taste', 'mouth', 'blep'] },
    { emoji: '👄', keywords: ['lips', 'mouth', 'kiss', 'talk', 'speak'] },
    { emoji: '💋', keywords: ['kiss', 'lips', 'lipstick', 'mark', 'love'] },
    { emoji: '🩸', keywords: ['blood', 'drop', 'donate', 'period', 'injury'] },
  ],
};

export default gestures;

